import { Link } from 'react-router-dom';
import type { Drama } from '@/types/content';

interface DramaCardProps {
  drama: Drama;
}

export default function DramaCard({ drama }: DramaCardProps) {
  const isOngoing = drama.status === '连载';

  return (
    <Link
      to={`/detail/tv/${drama.id}`}
      className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300"
    >
      <div className="relative w-full overflow-hidden" style={{ paddingTop: '133%' }}>
        <img
          src={drama.cover}
          alt={`${drama.title} 海报`}
          title={`${drama.title} - 电视剧资讯与剧情介绍`}
          className="absolute inset-0 h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-3 top-3 rounded-full px-2.5 py-1 text-xs font-label ${
            isOngoing ? 'bg-accent-500 text-primary-950' : 'bg-primary-500 text-background-50'
          }`}
        >
          {drama.status}
        </span>
        <div className="absolute inset-x-0 bottom-0 flex items-center gap-1 bg-gradient-to-t from-primary-950/80 to-transparent px-3 pb-2.5 pt-8 text-xs text-background-100">
          <i className="ri-fire-line text-accent-400" />
          <span>{drama.hot.toLocaleString()}</span>
          <span className="ml-1 opacity-80">热度</span>
        </div>
      </div>

      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-500">
          {drama.title}
        </h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {drama.genres.slice(0, 3).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>
        <p className="mt-3 line-clamp-2 text-sm leading-relaxed text-foreground-500">
          {drama.synopsis}
        </p>
        <div className="mt-3 flex items-center gap-3 border-t border-background-100 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-video-line" />
            全 {drama.episodes} 集
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {drama.updateDate}
          </span>
        </div>
      </div>
    </Link>
  );
}